export default "__VITE_ASSET__CKvTWBbr__"